export default "__VITE_ASSET__DliKBp7u__"